import MenuIcon from '@mui/icons-material/Menu'
import RouteIcon from '@mui/icons-material/Route'
import SearchIcon from '@mui/icons-material/Search'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { Link } from '@tanstack/react-router'
import { useRouterState } from '@tanstack/react-router'
import React from 'react'

import { useTranslation } from 'react-i18next'

const Navbar: React.FC = () => {
    const path = useRouterState({ select: r => r.location.pathname })
    const { t } = useTranslation()

    return (
        <BottomNavigation
            showLabels
            value={path}
            style={{
                paddingBottom: 'env(safe-area-inset-bottom)',
                height: `calc(56px + env(safe-area-inset-bottom))`,
            }}
        >
            <BottomNavigationAction
                label={t('Search')}
                value="/search"
                to="/search"
                component={Link}
                icon={<SearchIcon />}
            />
            <BottomNavigationAction
                label={t('Plan')}
                value="/plan"
                to="/plan"
                component={Link}
                icon={<RouteIcon />}
            />
            <BottomNavigationAction
                label={t('Settings')}
                value="/settings"
                to="/settings"
                component={Link}
                icon={<MenuIcon />}
            />
        </BottomNavigation>
    )
}

export default Navbar
